import React, { useState, useCallback } from "react";

export const PinContext = React.createContext();

const Pins = (props) => {
  const [pinnedSources, setPinnedSources] = useState(
    JSON.parse(localStorage.getItem("pinned-sources")) ?? []
  );

  const [pinnedPolicies, setPinnedPolicies] = useState(
    JSON.parse(localStorage.getItem("pinned-policies")) ?? []
  );

  const [pinnedTransfers, setPinnedTransfers] = useState(
    JSON.parse(localStorage.getItem("pinned-transfers")) ?? []
  );

  const [pinnedDynamicViews, setPinnedDynamicViews] = useState(
    JSON.parse(localStorage.getItem("pinned-dynamicviews")) ?? []
  );

  const [pinnedWorkspaces, setPinnedWorkspaces] = useState(
    JSON.parse(localStorage.getItem("pinned-workspaces")) ?? []
  );

  const update = useCallback(
    (type, data) => {
      if (type === "sources") {
        setPinnedSources(data);
      } else if (type === "policies") {
        setPinnedPolicies(data);
      } else if (type === "transfers") {
        setPinnedTransfers(data);
      } else if (type === "dynamicviews") {
        setPinnedDynamicViews(data);
      } else if (type === "workspaces") {
        setPinnedWorkspaces(data);
      }
    },
    [
      setPinnedSources,
      setPinnedPolicies,
      setPinnedTransfers,
      setPinnedDynamicViews,
      setPinnedWorkspaces,
    ]
  );

  const value = React.useMemo(() => {
    return {
      pinnedSources,
      pinnedPolicies,
      pinnedTransfers,
      pinnedDynamicViews,
      pinnedWorkspaces,
      update,
    };
  }, [
    pinnedSources,
    pinnedPolicies,
    pinnedTransfers,
    pinnedDynamicViews,
    pinnedWorkspaces,
    update,
  ]);

  return (
    <PinContext.Provider value={value}>{props.children}</PinContext.Provider>
  );
};

export default Pins;
